import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const FooterOne = ({ footerLight, style, footerGradient }) => {
  const { t } = useLanguage();

  return (
    <>
      <footer className='footer-section'>
        <div
          className={`footer-top footer-light' ${
            footerGradient ? 'bg-gradient' : ''
          }  text-black ptb-120`}
          style={style}
        >
          <div className='container'>
            <div className='row justify-content-between'>
              <div className='col-md-8 col-lg-4 mb-md-4 mb-lg-0'>
                <div className='footer-single-col'>
                  <div className='footer-single-col mb-4'>
                    <img
                      src='/assets/img/logo_infinitedev.svg'
                      alt='logo'
                      className='img-fluid logo-white w-50'
                    />
                  </div>
                  {/* <p>
                    {t('footer.newsletter.title')}
                  </p>

                  <form className='newsletter-form position-relative d-block d-lg-flex d-md-flex'>
                    <input
                      type='text'
                      className='input-newsletter form-control me-2'
                      placeholder={t('footer.newsletter.placeholder')}
                      name='email'
                      required=''
                      autoComplete='off'
                    />
                    <input
                      type='submit'
                      value={t('footer.newsletter.button')}
                      data-wait='Please wait...'
                      className='btn btn-primary mt-3 mt-lg-0 mt-md-0'
                    />
                  </form>
                  <div className='ratting-wrap mt-4'>
                    <h6 className='mb-0'>{t('footer.rating.title')}</h6>
                    <ul className='list-unstyled rating-list list-inline mb-0'>
                      <li className='list-inline-item'>
                        <i className='fas fa-star text-warning'></i>
                      </li>
                      <li className='list-inline-item'>
                        <i className='fas fa-star text-warning'></i>
                      </li>
                      <li className='list-inline-item'>
                        <i className='fas fa-star text-warning'></i>
                      </li>
                      <li className='list-inline-item'>
                        <i className='fas fa-star text-warning'></i>
                      </li>
                      <li className='list-inline-item'>
                        <i className='fas fa-star text-warning'></i>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
              <div className='col-md-12 col-lg-7 mt-4 mt-md-0 mt-lg-0'>
                <div className='row'>
                  <div className='col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0'>
                    <div className='footer-single-col'>
                      <h3>Main</h3>
                      <ul className='list-unstyled footer-nav-list mb-lg-0'>
                        <li>
                          <Link to='/' className='text-decoration-none'>
                            {t('footer.sections.primary.links.home')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/contact-us' className='text-decoration-none'>
                            {t('footer.sections.pages.links.contact')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/request-demo' className='text-decoration-none'>
                            {t('requestDemo.pageTitle')}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className='col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0'>
                    <div className='footer-single-col'>
                      <h3>Services</h3>
                      <ul className='list-unstyled footer-nav-list mb-lg-0'>
                        <li>
                          <Link to='/servico/ia-generativa' className='text-decoration-none'>
                            {t('features.featureFive.categories.ai.topics.generative.title')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/servico/ia-personalizada' className='text-decoration-none'>
                            {t('features.featureFive.categories.ai.topics.custom.title')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/servico/recrutamento-tech' className='text-decoration-none'>
                            {t('features.featureFive.categories.professionals.topics.recruitment.title')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/servico/outsourcing' className='text-decoration-none'>
                            {t('features.featureFive.categories.professionals.topics.outsourcing.title')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/servico/sistemas-plataformas' className='text-decoration-none'>
                            {t('features.featureFive.categories.software.topics.systems.title')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/servico/aplicativos' className='text-decoration-none'>
                            {t('features.featureFive.categories.software.topics.apps.title')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/servico/migracao-cloud' className='text-decoration-none'>
                            {t('features.featureFive.categories.infrastructure.topics.migration.title')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/servico/gerenciar-otimizar' className='text-decoration-none'>
                            {t('features.featureFive.categories.infrastructure.topics.management.title')}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className='col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0'>
                    <div className='footer-single-col'>
                      <h3>Industries</h3>
                      <ul className='list-unstyled footer-nav-list mb-lg-0'>
                        <li>
                          <Link to='/industria/agronegocio' className='text-decoration-none'>
                            {t('navbar.industries.agribusiness')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/industria/educacao' className='text-decoration-none'>
                            {t('navbar.industries.education')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/industria/logistica' className='text-decoration-none'>
                            {t('navbar.industries.logistics')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/industria/streaming' className='text-decoration-none'>
                            {t('navbar.industries.streaming')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/industria/varejo-e-moda' className='text-decoration-none'>
                            {t('navbar.industries.retail')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/industria/bets-igaming' className='text-decoration-none'>
                            {t('navbar.industries.betting')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/industria/financeiro' className='text-decoration-none'>
                            {t('navbar.industries.financial')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/industria/startups' className='text-decoration-none'>
                            {t('navbar.industries.startups')}
                          </Link>
                        </li>
                        <li>
                          <Link to='/industria/tecnologia' className='text-decoration-none'>
                            {t('navbar.industries.technology')}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className='col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0'>
                    <div className='footer-single-col'>
                      <h3>Cases</h3>
                      <ul className='list-unstyled footer-nav-list mb-lg-0'>
                        <li>
                          <Link to='/cases/rightee' className='text-decoration-none'>
                            Rightee
                          </Link>
                        </li>
                        <li>
                          <Link to='/cases/cardiohome' className='text-decoration-none'>
                            Cardiohome
                          </Link>
                        </li>
                        <li>
                          <Link to='/cases/grupovisco' className='text-decoration-none'>
                            Grupo Visco
                          </Link>
                        </li>
                    
                        <li>
                          <Link to='/cases' className='text-decoration-none'>
                            {t('navbar.cases.viewAll')}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`footer-bottom ${
            footerLight ? 'footer-light' : 'bg-dark'
          } ${footerGradient ? 'bg-gradient' : ''} text-white py-4`}
        >
          <div className='container'>
            <div className='row justify-content-between align-items-center'>
              <div className='col-md-7 col-lg-7'>
                <div className='copyright-text'>
                  <p className='mb-lg-0 mb-md-0'>
                    {t('footer.copyright')}
                  </p>
                </div>
              </div>
              <div className='col-md-4 col-lg-4'>
                <div className='footer-single-col text-start text-lg-end text-md-end'>
                  <ul className='list-unstyled list-inline footer-social-list mb-0'>
                    {/* <li className='list-inline-item'>
                      <Link to=''>
                        <i className='fab fa-facebook-f'></i>
                      </Link>
                    </li> */}
                    <li className='list-inline-item'>
                      <Link to='https://www.instagram.com/infinitedevsoftware/'>
                        <i className='fab fa-instagram'></i>
                      </Link>
                    </li>
                    <li className='list-inline-item'>
                      <Link to='https://www.linkedin.com/company/infinitedev/'>
                        <i className='fab fa-linkedin'></i>
                      </Link>
                    </li>
                    {/* <li className='list-inline-item'>
                      <Link to='/#'>
                        <i className='fab fa-github'></i>
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterOne;
